module.exports = __webpack_public_path__ + "static/img/8.660d09e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/places/8.jpg
// module id = EYw+
// module chunks = 1